import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import { ITableField } from '@/shared/Tables/Table'
import Tag from '@/shared/Tags/Tag'

const organizationsTableFields: ITableField<IOrganization, keyof IOrganization | 'equipmentCount' | 'usersCount'>[] = [
  {
    key: 'name',
    clientSideOrdering: true,
    width: '300px',
    header: 'Наименование',
    getter: (it) => it.name,
    sortGetter: (it) => it.name,
  },
  {
    key: 'equipmentCount',
    clientSideOrdering: true,
    width: '200px',
    header: 'Кол-во лифтов',
    getter: (it) => it._count.organizationsOnEquipment.toString(),
    sortGetter: (it) => it._count.organizationsOnEquipment,
  },
  {
    key: 'usersCount',
    clientSideOrdering: true,
    width: '200px',
    header: 'Кол-во сотрудников',
    getter: (it) => it._count.users.toString(),
    sortGetter: (it) => it._count.users,
  },
  {
    key: 'active',
    clientSideOrdering: true,
    width: '200px',
    header: 'Статус',
    getter: (it) => (it.active ? <Tag color="green">Активна</Tag> : <Tag color="red">Деактивирована</Tag>),
    sortGetter: (it) => it.name,
  },
]

export default organizationsTableFields
